module.exports = __webpack_public_path__ + "img/track_m.ce902e59.svg";